module.exports = __webpack_public_path__ + "img/gl.e3ff04a6.svg";